import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css'; // Import your custom CSS for the Login page


const Login = () => {
  const [username, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const emailInputRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // State to manage loading
  // Focus on the email input field when the component is mounted
  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, []);

  const fetchLastLoginDate = async (userId) => {
    try {
      const userToken = `${process.env.REACT_APP_AFTER_TOKEN}`;
      const response = await axios.get(`${process.env.REACT_APP_AUDIT_API_URL}/api/user-audit-logs`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        params: {
          'filters[auditType][$eq]': 'login',
          'filters[poimsUser][id][$eq]': userId,  // Use dynamic user ID here
          'sort': 'auditLogTime:desc',
          'pagination[page]': 1,
          'pagination[pageSize]': 1
        }
      });

      if (response.data.data && response.data.data.length > 0) {
        const lastLogin = response.data.data[0];
        const loginTime = lastLogin.auditLogTime;  // Directly use the auditLogTime string
        localStorage.setItem('loginTime', loginTime);
      }
    } catch (error) {
      console.error('Error fetching last login data:', error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Start showing loading message
    setErrorMessage(''); // Reset any previous error message
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/login`, { username, password });

      if (response.data) {
        const userData = {
          id: response.data.id,
          fullName: response.data.fullName,
          employeeId: response.data.employeeId,
          lastLoginTime: new Date().toISOString(),
          token: response.data.token,
          username: username,
          roleName: response.data.roleName,
          stateOrDistrictLevel: response.data.stateOrDistrictLevel,
          designation:response.data.designation,
        };
        // console.log(userData);
        localStorage.setItem('user', JSON.stringify(userData));
        fetchLastLoginDate(userData.id);

        const auditPayload = {
          data: {
            auditType: "login",
            auditLogTime: new Date().toISOString(),
            interface: "web",
            poimsUser: {
              id: userData.id
            }
          }
        };

        const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
        try {
          await axios.post(`${process.env.REACT_APP_AUDIT_API_URL}/api/user-audit-logs`, auditPayload, {
            headers: {
              Authorization: `Bearer ${token}`,
            }
          });
        } catch (auditError) {
          console.error('Error logging audit:', auditError);
        }


        navigate('/home');
        setTimeout(() => {
          window.location.reload();
        }, 1);
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage('Invalid user name or password');
    } finally {
      setLoading(false); // Stop showing loading message when done
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleLogin(event); // Trigger login on Enter key press
    }
  };

  const handleCancelButtonClick = () => {
    navigate('/about');
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Enter Login Details</h2>
      <div className="login-card">

        <form onSubmit={handleLogin} onKeyDown={handleKeyDown} className='login-form'>
          <div className="form-group-login">
            <label className='login-label' htmlFor="email">User Name</label>
            <input
              type="text"
              id="email"
              className="form-input"
              value={username}
              onChange={(e) => setEmail(e.target.value)}
              required
              ref={emailInputRef}
            />
          </div>
          <div className="form-group-login">
            <label className='login-label' htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {loading && <div className="loading-message">Please wait...</div>}
          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="LoginButtons">
            <button onClick={handleCancelButtonClick} className="btn-cancel" type="button">CANCEL</button>
            <button type="submit" className="login-btn">LOGIN</button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default Login;
